<template>
  <div v-if="show_event_dates">
    <h3
      class="title color--lg"
      v-if="block.isShowed('text_event_dates') && text"
    >
      {{ text }}
    </h3>

    <project-event-dates
      class="bold d-flex margin__t--12"
      :project="project"
      :show-start-date="block.isShowed('start_date')"
      :show-end-date="block.isShowed('end_date')"
    >
      <template #icon>
        <fa-icon
          class="color--prim icon margin__r--12 event__icon"
          :icon="['fas', 'calendar-clock']"
        />
      </template>
    </project-event-dates>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { useI18n } from '@/vendors/i18n'

const ProjectEventDates = defineAsyncComponent(() => import('&/modules/project/ProjectEventDates'))

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()

const objects = inject('objects', {})

const project = objects.value.project

const show_event_dates = (block.isShowed('start_date') && !!project.event_start_date) || (block.isShowed('end_date') && !!project.event_end_date)

const text = computed(() => translate(block.getText('event_dates')))
</script>

<style lang="scss" scoped>
.title {
  font-size: rem(14px);
}

.event {
  line-height: 1.375;

  &__icon {
    position: relative;
    top: 3px;
  }
}
</style>